/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { TaskDatumModel, TaskDatumType } from '../../../../../../../models/task.model';

@Component({
  selector: 'datum-viewer',
  templateUrl: './datum-viewer.component.html',
  styleUrls: ['./datum-viewer.component.scss'],
  standalone: false
})
export class DatumViewerComponent implements OnInit {
  @Input() taskDatumMap?: Map<string, TaskDatumModel> = new Map<string, TaskDatumModel>();
  TaskDatumType = TaskDatumType;
  constructor() {}

  ngOnInit(): void {}
  noSort = () => 0;
}
